import { TableField, defaultSimNaoBooleanFormatter } from "../../table-field";

const nomeRelatorio: TableField = {
  key: "IdRelatorioNavigation.DsRelatorio",
  label: "Nome",
  tdClass: ["align-middle", "text-left"],
  thClass: "text-left",
  sortable: false,
};
const obrigatorio: TableField = {
  key: "Obrigatorio",
  label: "Obrigatório?",
  tdClass: "align-middle",
  thClass: "text-center",
  formatter: defaultSimNaoBooleanFormatter,
  sortable: true,
};
const actions: TableField = {
  key: "actions",
  label: "Informações",
  tdClass: ["align-middle", "col-actions"],
  thClass: "text-center",
  sortable: false,
};

export const fieldsRelatoriosPCM: TableField[] = [nomeRelatorio, actions];
